import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'app/hooks'

import { MB } from 'utils/constants'
import uploadApi from 'app/axiosApi'
import { ERRORS } from 'locales/locales'

import DropdownAlert from 'components/dropdown-alert/DropdownAlert'

const useUploadPhoto = (cb: (url: string, fileData?: File) => void, type: string) => {
  const [isUploadLoading, setIsLoading] = useState(false)
  const [fileInfo, setFileInfo] = useState<{ blobUrl?: string; file?: File }>({})
  const { t } = useTranslation()
  const accessToken = useAppSelector((state) => state.auth.accessToken)
  const myId = useAppSelector((state) => state.auth.user?._id)
  const systemData = useAppSelector((state) => state.system.data)

  const onUploadPhoto = async (selectedFile: FileList) => {
    const file = Array.from(selectedFile)
    const url: string = URL.createObjectURL(file[0])
    if (file[0]?.size / MB > parseInt(systemData?.fileSizeLimit ?? 50)) {
      DropdownAlert.ref.show({
        isError: true,
        message: t(ERRORS.FILE_SIZE_ERROR, {
          fileSize: systemData?.fileSizeLimit,
          fileSizeType: 'MB',
          file_name: file[0].name,
        }),
      })
      return
    }
    
    // Sadece blob URL'ini callback'e gönder, dosya bilgisini de sakla
    cb(url, file[0])
    setFileInfo({ blobUrl: url, file: file[0] })
  }

  const uploadToServer = async (file: File, id?: string) => {
    setIsLoading(true)
    try {
      const getUrl = () => {  
        if(type === 'logo' || type === 'favicon') {
          return `files/upload/?from=${type}`
        }
        if(type === 'team-avatar') {
          return `files/upload/?from=${type}&teamId=${id}`
        }
        if(type === 'avatar') {
          return `files/upload/?from=${type}&userId=${myId}`
        }
        if(type === 'inAppBrowser') {
          return `files/upload/?from=${type}&inAppBrowserId=${id}`
        }

        return `files/uploads/?from=${type}${id ? `&roomId=${id}` : ""}`
      }

      const result = await uploadApi.uploadFile(
        getUrl(),
        [file],
        "file",
        { params: { type, id } },
        undefined,
        accessToken,
      )
      setIsLoading(false)
      return result?.data?.success
    } catch (err) {
      setIsLoading(false)
      console.error(err)
      throw err
    }
  }

  return {
    isUploadLoading,
    onUploadPhoto,
    uploadToServer,
    fileInfo
  }
}

export default useUploadPhoto
